import BaseService from "src/packages/BaseService";

export default class SubscriptionService extends BaseService {
	static get className () {
		return "subscription";
	}

	static async getProjectSubscription (projectId) {
		return BaseService.getService().get(`/subscription/getByProject/${projectId}`).then((response) => {
			return response.data;
		});
	}

	static async getUserSubscriptions (userId) {
		return BaseService.getService().get(`/subscription/getByUser/${userId}`).then((response) => {
			return response.data;
		});
	}
}
